import { mapState, mapGetters, mapActions } from "vuex";
import AppIcon from "@/components/AppIcon";
import PpcSbBudgetAllocation from "@/components/PpcSbBudgetAllocation";
import AppPagination from "@/components/AppPagination";
import { EVENTS } from "../utils";
export default {
  name: "PpcSbProductPrioritization",
  components: {
    AppIcon,
    AppPagination,
    PpcSbBudgetAllocation
  },
  props: {
    currency: {
      type: String
    },
    selected_profile_id: {
      type: String
    },
    still_initializing: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dataLoading: true,
      page: 1,
      perPage: 20
    };
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      me: state => state.auth.me,
      sb_product_prioritization: state => state.ppc_settings.sb_product_prioritization,
      total_rows: state => state.ppc_settings.sb_product_prioritization_total_rows
    }),
    ...mapGetters(["workspaceCurrent"])
  },
  methods: {
    ...mapActions(["authStatus", "workspaceList", "ppcSbProductPrioritizationUpdate"]),
    async changePage(newPage) {
      this.page = newPage;
      await window.$bus.trigger(EVENTS.REFRESH_PPC_SETTINGS_SB_PRODUCT_PRIORITIZATION, {
        page_limit: this.perPage,
        page_offset: newPage
      });
    },
    onItemUpdate(item) {
      this.ppcSbProductPrioritizationUpdate(item);
    },
    async changeElements(elementsPerPage) {
      this.page = 1;
      this.perPage = elementsPerPage;
      await window.$bus.trigger(EVENTS.REFRESH_PPC_SETTINGS_SB_PRODUCT_PRIORITIZATION, {
        page_limit: elementsPerPage,
        page_offset: 1
      });
    }
  }
};